import React, { useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Dialog, DialogTitle, DialogContent, TextField, InputAdornment, IconButton, Snackbar } from "@mui/material";
import QRCode from "qrcode.react";
// import CopyQrLink from "../CopyQrLink";
import { Link } from "react-router-dom";
import { Printer, X, ClipboardCopy } from "lucide-react";

import ApiHelper from "../../../../Utils/API/apiHelper";

export default function ApiMeasurementShareDialog(props) {
  const componentRef = useRef();
  const classes = useStyles();
  const appSettings = ApiHelper.appSettings;

  const [openToast, setOpenToast] = useState(false);

  const handlePrint = () => {
    const content = componentRef.current;
    const printWindow = window.open("", "_blank", "width=800,height=600");

    // Add the content to the new window
    printWindow.document.write(`
          <html>
            <head>
              <title>Print QR Code</title>
              <style>
                /* Add custom print styles here */
                body { font-family: Arial, sans-serif; margin: 20px; }
                .print-source { height: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center; }
                @media print {
                  body {
                    margin: 0;
                    padding: 0;
                  }
                  .print-source {
                    width: 100%;
                  }
                }
              </style>
            </head>
            <body>
              <div class="print-source">
                <h1 style="text-align: center;">${props.apiAction} (${props.apiName})</h1>
                ${content.innerHTML}
              </div>
            </body>
          </html>
        `);

    // Trigger the print dialog
    printWindow.document.close();
    printWindow.print();
  };

  const handleCopy = () => {
    handleOpenToast();
    navigator.clipboard.writeText(props.qrUrl);
  };

  const handleOpenToast = () => {
    setOpenToast(true);
  };

  const handleCloseToast = (reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenToast(false);
  };

  const action = (
    <React.Fragment>
      <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseToast}>
        <X fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <Dialog className={classes.dialog} open={props.openQr} onClose={props.handleCloseQr} classes={{ paper: classes.dialogPaper }} maxWidth={"lg"}>
      <div className={classes.dialog__head}>
        <DialogTitle className={classes.dialog__title} id="draggable-dialog-title">
          {props.apiAction}
        </DialogTitle>
        <div className={classes.head__buttonContainer}>
          <button className={classes.iconButton} onClick={handlePrint}>
            <Printer size={19} className={classes.head__printIcon} />
          </button>
          <button onClick={props.handleCloseQr} className={classes.dialog__closeButton}>
            <X size={19} />
          </button>
        </div>
      </div>
      <DialogContent className={classes.dialog__contentContainer}>
        <div className={classes.dialog__content}>
          <div className={classes.qrContainer}>
            <div
              className="print-source"
              style={{ position: "relative", height: "100%", flexDirection: "column", display: "flex", justifyContent: "center", alignItems: "center", alignContent: "center" }}
              ref={componentRef}
            >
              <QRCode id="Qr" value={props.qrUrl} bgColor={"#ffffff"} renderAs={"svg"} size={240} />
              <div style={{ position: "relative", width: "240px" }}>
                <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "8px" }}>Powered by Flagstone</div>
              </div>
            </div>
          </div>
          <div className={classes.copyUrl}>
            <TextField
              className={classes.inputField}
              label="Copy link to clipboard:"
              fullWidth
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleCopy}>
                      <ClipboardCopy />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              variant="outlined"
              value={props.qrUrl}
            ></TextField>

            <Snackbar open={openToast} autoHideDuration={3000} onClose={handleCloseToast} message="Link copied to clipboard" action={action} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

const useStyles = makeStyles(() => ({
  dialog: {
    margin: "auto",
  },

  dialogPaper: {
    width: "400px !important",
    height: "auto",
    borderRadius: "6px !important",
  },

  dialog__head: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",

    padding: "16px 16px 0px 16px !important",
    marginBottom: "8px !important",
  },

  dialog__title: {
    fontSize: "24px !important",
    fontFamily: "Lato, sans-serif !important",
    fontWeight: "normal",

    lineHeight: "100% !important",

    padding: "0px !important",
  },

  head__buttonContainer: {
    display: "flex",
    gap: "8px",
  },

  dialog__closeButton: {
    backgroundColor: "#F5F5F5",
    border: "none",
    cursor: "pointer",

    padding: "3px !important",
    height: "25px !important",

    borderRadius: "3px",

    transition: "all 0.2s",

    "&:hover": {
      backgroundColor: "#D84949",
      color: "#F5F5F5",
    },

    "&:focus-visible": {
      outline: "#4654FB auto 1px",
    },
  },

  iconButton: {
    backgroundColor: "#F5F5F5",
    border: "none",
    cursor: "pointer",

    padding: "3px !important",
    height: "25px !important",

    borderRadius: "3px",

    transition: "all 0.2s",

    "&:hover": {
      backgroundColor: "#EDEDED",
    },

    "&:focus-visible": {
      outline: "#4654FB auto 1px",
    },
  },

  iconButton__icon: {
    width: "16px",
    height: "16px",

    strokeWidth: "1.4px",

    color: "#0C0E29",
  },

  dialog__contentContainer: {
    padding: "0px 16px !important",
    marginBottom: "16px",

    // remove scrollbar
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
  },

  dialog__content: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",

    margin: "0px !important",
  },

  qrContainer: {
    width: "100%",

    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    border: "1px solid #EDEDED",
    borderRadius: "8px",

    padding: "16px",
    marginTop: "8px",
  },

  inputField: {
    width: "100%",
    marginTop: "10px",
  },

  copyUrl: {
    width: "100%",
    marginTop: "16px",
  },
}));
